import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginLayout } from '@cfp/shared/ui/login';
import { FooterText } from '../../components';

@Component({
  selector: 'cfp-authentication-page',
  templateUrl: './authentication-page.html',
  imports: [RouterOutlet, FooterText, LoginLayout],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthenticationPage {
  constructor() {
    window.scrollTo(0, 0);
  }
}
